"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "canal-san-bovo": {
    "d24e8d71": [{
      "hkey": "289afd9c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "canale": [{
      "hkey": "289afd9c",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ef7060b4": [{
      "hkey": "b9789c71",
      "slug": "prade-cicona",
      "name": "Prade-Cicona",
      "primary": true,
      "skipSearch": false
    }],
    "prade": [{
      "hkey": "b9789c71",
      "slug": "prade-cicona",
      "name": "Prade-Cicona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "dd40a527": [{
      "hkey": "b60a0861",
      "slug": "ronco-chiesa",
      "name": "Ronco-Chiesa",
      "primary": true,
      "skipSearch": false
    }],
    "ronco": [{
      "hkey": "b60a0861",
      "slug": "ronco-chiesa",
      "name": "Ronco-Chiesa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;